module.exports = __webpack_public_path__ + "static/up_cloud-d69662a526f2260c08d129c2503145ad.svg";